import { useI18n } from '@runtime/core/i18n/i18n'
import { useUser } from '@runtime/core/user/userContext'

import { Button } from '@runtime/components/ui/Button'
import styles from '@runtime/features/profile/ProfileButton.module.scss'

export default function ProfileButton({
  compactOnMobile = false,
  className,
}: {
  compactOnMobile?: boolean
  className?: string
}) {
  const { t } = useI18n()
  const { user, authToken, setLoginOpen } = useUser()

  const isAuthed = !!authToken
  const label = isAuthed
    ? user?.pseudo || t('profile.loginButton.labelFallback')
    : t('profile.loginButton.labelFallback')
  const avatarUrl = isAuthed ? user?.avatarDataUrl || null : null

  // Default pictogram: profile icon.
  const initial = '👤'

  return (
    <Button
      size="s"
      className={[
        styles.loginBtn,
        compactOnMobile && styles.compactOnMobile,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      data-testid="login-button"
      aria-label={label}
      onClick={() => setLoginOpen(true)}
    >
      <span
        className={styles.loginBtnAvatar}
        style={
          avatarUrl
            ? {
                backgroundImage: `url(${avatarUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }
            : undefined
        }
      >
        {!avatarUrl && (
          <span className={styles.loginBtnAvatarIcon}>{initial}</span>
        )}
      </span>
      <span className={styles.loginBtnText}>
        <span className={styles.loginBtnLabel} data-testid="login-button-label">
          {label}
        </span>
      </span>
    </Button>
  )
}
